function zipCountyEventHandlers(appContext) {
  // Apply input masks to zip code and date fields
  $('#zip').inputmask('99999', { placeholder: ' ' });
  $('input[name$="Date"]').each(function () {
    $(this).inputmask('mm/dd/yyyy', { showMaskOnHover: false });
  });

  // Zip code lookup on change and keyup events and when the page loads if a zip code is already entered
  const zipURI = `${appContext}/zipcode?zip=`;

  $('#zip').on('change keyup', function () {
    findZipCode(zipURI + $(this).val(), null, '#state');
  });

  if ($('#zip').val() != '') {
    findZipCode(zipURI + $('#zip').val(), $('#county').val(), '#state');
  }

  // County change event to remove the blank option and toggle enrollment fields based on the selected state
  $('#county').change(function () {
    var county = $(this).find('option:selected');
    if (county.val() !== '') $(this).find("option[value='']").remove();
    var stateAbbreviation = county.attr('state');
    toggleEnrollmentFields(stateAbbreviation);
  });
}
